import React from 'react';
import { Car, ShieldHalf, Map, Siren, ClipboardList, Check } from 'lucide-react';
import { Card, ReadMore } from '../ui';

export const PROTECTION = [
  [ShieldHalf, 'Scorta e protezione ravvicinata', 'Operatori qualificati che accompagnano il viaggiatore negli spostamenti e negli incontri, con o senza scorta armata dove la legge locale lo consente.'],
  [Car, 'Trasferimenti sicuri e mezzi blindati', "Autista di fiducia dall'aeroporto all'hotel e per tutta la permanenza, anche con veicoli blindati e percorsi pianificati."],
  [Map, 'Guide locali e fixer', 'Referenti sul posto che conoscono lingua, quartieri e consuetudini: interpreti, accompagnatori e supporto logistico.'],
  [Siren, 'Emergenza ed evacuazione', 'Piano di emergenza, assistenza 24/7 e, in caso di crisi, evacuazione sanitaria o di sicurezza verso un luogo protetto.'],
  [ClipboardList, 'Valutazione del rischio sul posto', 'Sopralluogo e analisi di hotel, sedi e itinerari prima della trasferta, con le misure consigliate.'],
];

export default function TravelProtection({ picked, onToggle }) {
  return (
    <Card className="p-6 mb-6" data-testid="travel-protection">
      <p className="text-xs uppercase tracking-[0.25em] text-[#D4AF37] mb-2">Protezione delle persone in viaggio</p>
      <h2 className="font-heading text-lg mb-2">Servizi di sicurezza per le trasferte a rischio</h2>
      <ReadMore className="text-sm text-[#A3A3A3] max-w-3xl mb-5">Per i Paesi o le situazioni più delicate Smart Info organizza, tramite partner qualificati, la protezione sul posto dei tuoi viaggiatori. Seleziona i servizi che ti interessano e richiedi una consulenza: valutiamo insieme rischi, tempi e costi.</ReadMore>
      <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-3">
        {PROTECTION.map(([Icon, t, d], i) => {
          const on = picked.includes(t);
          return (
            <div key={t} role="button" tabIndex={0} onClick={() => onToggle(t)} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onToggle(t); } }} aria-pressed={on} data-testid={`travel-protection-${i}`}
              className={`text-left border rounded-sm p-4 cursor-pointer transition-colors ${on ? 'border-[#D4AF37] bg-[#D4AF37]/10' : 'border-[#1F242C] hover:border-[#D4AF37]/60'}`}>
              <span className="flex items-center justify-between mb-3"><Icon size={18} className="text-[#D4AF37]" />{on && <Check size={16} className="text-[#D4AF37]" />}</span>
              <p className="text-sm font-semibold mb-1">{t}</p>
              <ReadMore clamp="max-sm:line-clamp-2" className="text-sm text-[#A3A3A3] leading-relaxed">{d}</ReadMore>
            </div>
          );
        })}
      </div>
    </Card>
  );
}
